module.exports = __webpack_public_path__ + "static/media/01.4d724f2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/rank/01.jpg
// module id = 846
// module chunks = 0